var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"skip"},[_c('span',[_vm._v(_vm._s(_vm.label))]),_c('router-link',{staticClass:"skip-link",attrs:{"to":_vm.link}},[_vm._v(" "+_vm._s(_vm.linkLabel)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }